// extracted by mini-css-extract-plugin
export default {"section":"ContactSection_section__UkYbf"};